import React from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { CheckCircle } from "lucide-react"; // ✅ proper icon import
import rzpLogo from "../assets/Logo/logo.png";

export default function FeaturesPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const email =
    location.state?.email || JSON.parse(localStorage.getItem("user"))?.email;

  // ✅ Updated content for Safety Audit
  const features = [
    {
      title: "Comprehensive Inspections",
      description:
        "Perform detailed safety audits across plants, sites, and operations to identify risks early.",
    },
    {
      title: "Regulatory Compliance",
      description:
        "Ensure alignment with OSHA, ISO, and other safety standards to avoid penalties.",
    },
    {
      title: "Custom Checklists",
      description:
        "Create and manage audit checklists tailored to your industry and company policies.",
    },
    {
      title: "Real-Time Reporting",
      description:
        "Capture findings instantly with digital forms, photos, and automated reports.",
    },
    {
      title: "Corrective Actions Tracking",
      description:
        "Assign, monitor, and verify corrective actions to close audit findings effectively.",
    },
    {
      title: "Analytics & Insights",
      description:
        "Track safety trends with dashboards and analytics for continuous improvement.",
    },
  ];

  const handleBuyPlan = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/payment/order`,
        { email }
      );
      const { id: order_id, amount, currency } = response.data;

      const options = {
        key: "rzp_test_t4LUM04KXw6wHc",
        name: "The Safety Master",
        image: rzpLogo,
        amount,
        currency,
        order_id,
        handler: async (response) => {
          try {
            const res = await axios.post(
              `${process.env.REACT_APP_API_URL}/payment/verify`,
              response
            );
            if (res.data.success) {
              navigate("/success");
            }
          } catch {
            navigate("/failure");
          }
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      alert("Payment initiation failed");
    }
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <div className="text-center py-16 bg-blue-500 text-white">
        <h1 className="text-4xl font-bold">Safety Audit Features</h1>
        <p className="mt-4 text-lg">
          Streamline audits, ensure compliance, and build a safer workplace.
        </p>
      </div>

      {/* Feature Cards Section */}
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-8 bg-white shadow-lg rounded-xl text-center transition-all duration-300 hover:scale-105 hover:shadow-2xl"
            >
              <CheckCircle className="w-14 h-14 text-blue-600 mx-auto mb-4 transition-all duration-300 hover:text-blue-800" />
              <h3 className="text-2xl font-semibold transition-all duration-300 hover:text-blue-700">
                {feature.title}
              </h3>
              <p className="text-gray-600 mt-2 text-lg transition-all duration-300 hover:text-gray-800">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Call to Action */}
      <div className="text-center py-12 bg-blue-500 text-white">
        <h2 className="text-3xl font-bold animate-fadeInUp">
          Ready to Get Started?
        </h2>
        <button
          onClick={handleBuyPlan}
          className="mt-4 px-6 py-3 bg-white text-blue-600 font-semibold rounded-full shadow-md transition-all duration-300 transform hover:bg-gray-200 hover:scale-110 hover:shadow-lg"
        >
          Buy Now
        </button>
      </div>
    </div>
  );
}
